module.exports = __webpack_public_path__ + "img/9788952743138.c89f33de.jpg";